export const MONCASH_URL_REQUEST = 'MONCASH_URL_REQUEST';
export const MONCASH_URL_SUCCESS = 'MONCASH_URL_SUCCESS';
export const MONCASH_URL_FAILED = 'MONCASH_URL_FAILED';

export const MONCASH_INFO_REQUEST = 'MONCASH_INFO_REQUEST';
export const MONCASH_INFO_SUCCESS = 'MONCASH_INFO_SUCCESS';
export const MONCASH_INFO_FAILED = 'MONCASH_INFO_FAILED';
